import React, { useState, useContext, useEffect } from 'react';
import {
	TextField,
	Button,
	Paper,
	Typography,
	MenuItem,
	InputLabel,
	Grid,
	FormControl,
	Select,
	InputAdornment,
	IconButton
} from '@mui/material';
import { isEmpty } from 'lodash';
import { Stack } from '@mui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faSave,
	faPenToSquare,
	faCodePullRequest,
	faGears,
	faFlag
} from '@fortawesome/free-solid-svg-icons';
import { getToken } from '../../../api/Account';
import { DataContext } from '../../../context/DataContext';

import { isAccess, simpleMessage } from '../../../helpers/Helpers';
import { DIAS_ATENCION, requiereDiaAtencion } from '../../../helpers/diaAtencion';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import {
	getCreditByIdAsync,
	remakeCreditAsync,
	reportarAsync,
	updateCreditAsync
} from '../../../api/Credits';
import { getPeriodicidadListAsync } from '../../../api/Periodicidad';
import { getGestoresAsync, getPromotoresAsync } from '../../../api/Users';
import { getInteresListAsync } from '../../../api/InteresCorriente';
import { getPlazoByPeriodicidadAsync } from '../../../api/Plazo';
import Swal from 'sweetalert2';
import SmallModal from '../../../components/modals/SmallModal';
import Reestructuracion from './Reestructuracion';
import MediumModal from '../../../components/modals/MediumModal';
import EditarFiador from './fiadorComponents/EditarFiador';

// Titulo de las tarjetas de campos, con el mismo tratamiento que el resto del
// rediseño: Poppins 600 a 16px sobre el color de texto normal.
const tituloTarjetaSx = {
	fontFamily: "'Poppins', sans-serif",
	fontWeight: 600,
	fontSize: 16,
	color: 'text.primary',
	marginBottom: '18px'
};

const CreditDetails = ({ id, setClientName, setDataCredit }) => {
	const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);
	const token = getToken();

	const [selectedClient, setSelectedClient] = useState(null);

	const [periodicidadList, setPeriodicidadList] = useState([]);
	const [selectedPeriodicidad, setSelectedPeriodicidad] = useState('');

	const [diaAtencion, setDiaAtencion] = useState('');

	const [plazoList, setPlazoList] = useState([]);
	const [selectedPlazo, setSelectedPlazo] = useState('');

	const [interesCorrienteList, setInteresCorrienteList] = useState([]);
	const [selectedInteresCorriente, setSelectedInteresCorriente] = useState('');

	const [gestorList, setGestorList] = useState([]);
	const [selectedGestor, setSelectedGestor] = useState('');

	const [promotorList, setPromotorList] = useState([]);
	const [selectedPromotor, setSelectedPromotor] = useState('');

	const [montoPrincipal, setMontoPrincipal] = useState('');
	const [destino, setDestino] = useState('');

	const [fechaPrimeraCuota, setFechaPrimeraCuota] = useState(new Date());
	const [fechaEntrega, setFechaEntrega] = useState(new Date());
	const [fechaVenc, setFechaVenc] = useState(new Date());

	const [isEdit, setIsEdit] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const [isReportado, setIsReportado] = useState(false);
	const [tipoCredito, setTipoCredito] = useState(0);

	const [fiadorList, setFiadorList] = useState([]);
	const [selectedfiador, setselectedFiador] = useState([]);
	const [showModalFiafor, setShowModalFiador] = useState(false);
	const [isUpdate, setIsUpdate] = useState(false);
	const [isAbonado, setIsAbonado] = useState(false);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getCreditByIdAsync(token, id);

			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setClientName(result.data.result.client.fullName);

			if (result.data.result.quotes.length > 0) {
				setIsAbonado(true);
			}
			setDataCredit(result.data.result);
			setSelectedClient(result.data.result.client);

			const resultPer = await getPeriodicidadListAsync(token);
			if (!resultPer.statusResponse) {
				setIsLoading(false);
				if (resultPer.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultPer.error, 'error');
				return;
			}
			setPeriodicidadList(resultPer.data.result);

			const resultGestores = await getGestoresAsync(token, result.data.result.sucursal.id);
			if (!resultGestores.statusResponse) {
				setIsLoading(false);
				if (resultGestores.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultGestores.error, 'error');
				return;
			}
			setGestorList(resultGestores.data.result);

			await getPromotores(result.data.result.sucursal.id);

			const resultIC = await getInteresListAsync(token);
			if (!resultIC.statusResponse) {
				setIsLoading(false);
				if (resultIC.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultIC.error, 'error');
				return;
			}
			setInteresCorrienteList(resultIC.data.result);

			const resultPlazo = await getPlazoByPeriodicidadAsync(
				token,
				result.data.result.periocidad.id
			);
			if (!resultPlazo.statusResponse) {
				setIsLoading(false);
				if (resultPlazo.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultPlazo.error, 'error');
				return;
			}

			setTipoCredito(result.data.result.tipoCredito);
			setFechaVenc(new Date(result.data.result.fechaVencimiento));
			setPlazoList(resultPlazo.data.result);
			setMontoPrincipal(result.data.result.montoPrincipal);
			setSelectedGestor(result.data.result.gestor);
			setDestino(result.data.result.destino);
			setSelectedPeriodicidad(result.data.result.periocidad.id);
			setDiaAtencion(result.data.result.diaAtencion ?? '');
			setSelectedPlazo(result.data.result.plazo.id);
			setSelectedInteresCorriente(result.data.result.tasaInteresCorriente.id);
			setFechaEntrega(new Date(result.data.result.fechaEntrega));
			setFechaPrimeraCuota(new Date(result.data.result.fechaPrimeraCuota));
			setSelectedPromotor(result.data.result.promotor);
			setFiadorList(result.data.result.fiadores);
			setIsLoading(false);
		})();
	}, [isUpdate]);

	//Devuelve un entero positivo
	const funtionSetMontoSolicitado = (value) => {
		if (/^[0-9]+$/.test(value.toString()) || value === '') {
			setMontoPrincipal(value);
			return;
		}
	};

	const handleChangePeriodicidad = async (event) => {
		const selected = periodicidadList.filter((item) => item.id == event.target.value);
		let dias = selected[0].cuotaDias;

		var newDate = new Date();
		newDate.setDate(newDate.getDate() + dias);

		setFechaPrimeraCuota(newDate);
		setPlazoList([]);
		setSelectedPeriodicidad(event.target.value);

		if (event.target.value !== '') {
			setIsLoading(true);
			const result = await getPlazoByPeriodicidadAsync(token, event.target.value);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setPlazoList(result.data.result);
			setIsLoading(false);
		} else {
			setPlazoList([]);
		}
	};

	const periodicidadSeleccionada = periodicidadList.find(
		(item) => item.id === Number(selectedPeriodicidad)
	);
	const mostrarDiaAtencion = requiereDiaAtencion(periodicidadSeleccionada);

	const saveChanges = async () => {
		if (validate()) {
			const datos = {
				id,
				montoPrincipal,
				fechaEntrega,
				fechaPrimeraCuota,
				destino,
				periocidadId: selectedPeriodicidad,
				diaAtencion: mostrarDiaAtencion ? diaAtencion : null,
				plazoId: selectedPlazo,
				interesCorrienteId: selectedInteresCorriente,
				gestor: selectedGestor,
				promotor: selectedPromotor,
				tipoCredito
			};

			setIsLoading(true);
			const result = await updateCreditAsync(token, datos);
			if (!result.statusResponse) {
				setIsLoading(false);

				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}

				simpleMessage(result.error, 'error');
				return;
			}

			setIsLoading(false);
			setIsEdit(false);
			simpleMessage('Crédito actualizado...!', 'success');
		}
	};

	//Validando campos ingresados
	const validate = () => {
		let isValid = true;
		if (isEmpty(selectedClient)) {
			simpleMessage('Debe seleccionar un cliente', 'error');
			return (isValid = false);
		}

		if (montoPrincipal === '') {
			simpleMessage('Debe ingresar un monto', 'error');
			return (isValid = false);
		}

		if (fechaPrimeraCuota === '') {
			simpleMessage('Debe ingresar fecha de primera cupta', 'error');
			return (isValid = false);
		}

		if (fechaPrimeraCuota === '') {
			simpleMessage('Debe ingresar una fecha de entrega', 'error');
			return (isValid = false);
		}

		if (selectedGestor === '') {
			simpleMessage('Debe seleccionar un gestor', 'error');
			return (isValid = false);
		}

		if (selectedPlazo === '') {
			simpleMessage('Debe seleccionar un plazo', 'error');
			return (isValid = false);
		}

		if (selectedInteresCorriente === '') {
			simpleMessage('Debe seleccionar una tasa de interes', 'error');
			return (isValid = false);
		}

		if (isEmpty(destino)) {
			simpleMessage('Debe seleccionar un destino de credito', 'error');
			return (isValid = false);
		}
		return isValid;
	};

	const remakeCredit = async () => {
		Swal.fire({
			title: '¿Estas Seguro de Rehacer este Crédito?',
			// text: "...!",
			icon: 'warning',
			showCancelButton: true,

			confirmButtonColor: '#1d4ed8',
			cancelButtonColor: '#d83a3f',

			confirmButtonText: 'Rehacer!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = await remakeCreditAsync(token, id);
					if (!result.statusResponse) {
						setIsLoading(false);
						if (result.error === 'Unauthorized') {
							setIsUnautorized(true);
							return;
						}
						simpleMessage(result.error, 'error');
						return;
					}
					Swal.fire('Listo!', '', 'success');
					setIsLoading(false);
					setIsEdit(false);
				})();
			}
		});
	};

	const getPromotores = async (id) => {
		const result = await getPromotoresAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setPromotorList(result.data.result);
	};

	const reportar = async () => {
		Swal.fire({
			title: '¿Estas Seguro de Reportarlo?',
			// text: "...!",
			icon: 'warning',
			showCancelButton: true,

			confirmButtonColor: '#1d4ed8',
			cancelButtonColor: '#d83a3f',

			confirmButtonText: 'Reportar',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = await reportarAsync(token, id);
					if (!result.statusResponse) {
						setIsLoading(false);
						if (result.error === 'Unauthorized') {
							setIsUnautorized(true);
							return;
						}
						simpleMessage(result.error, 'error');
						return;
					}
					Swal.fire('Listo!', '', 'success');
					setIsReportado(!isReportado);
					setIsLoading(false);
					setIsEdit(false);
				})();
			}
		});
	};

	const onClickEditFiador = (item) => {
		setShowModalFiador(true);
		setselectedFiador(item);
	};

	return (
		<div>
			{/* Sin Container: el contenedor de pestañas ya define el ancho y el
			    padding, y anidarlo agregaba margenes de mas. */}
			<Paper
				sx={{
					padding: '20px'
				}}
				>
					<Stack
						direction={{ xs: 'column', sm: 'row' }}
						alignItems="center"
						justifyContent={'space-between'}
					>
						<Typography
							sx={{
								fontFamily: "'Poppins', sans-serif",
								fontWeight: 600,
								fontSize: 16,
								color: 'text.primary'
							}}
						>
							Datos del crédito
						</Typography>

						{/* Jerarquia de acciones, como en CrediHouse_Formats: solo la accion
						    principal lleva el verde de marca; las demas van en neutro. Antes
						    eran cuatro botones en amarillo, amarillo, magenta y rojo, todos
						    compitiendo por la atencion. */}
						<Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
							{isAccess(access, 'CREDITS UPDATE') ? (
								<>
									<Button
										onClick={() => {
											setIsEdit(!isEdit);
										}}
										variant="outlined"
										color="primary"
										startIcon={<FontAwesomeIcon icon={faPenToSquare} />}
										sx={{ whiteSpace: 'nowrap' }}
									>
										{isEdit ? 'Cancelar edición' : 'Editar'}
									</Button>

									<Button
										onClick={() => {
											reportar();
										}}
										variant="outlined"
										startIcon={<FontAwesomeIcon icon={faFlag} />}
										sx={{
											whiteSpace: 'nowrap',
											color: 'text.secondary',
											borderColor: 'divider'
										}}
									>
										Reportar
									</Button>
								</>
							) : (
								<></>
							)}

							{isAccess(access, 'CREDITS REGEN') ? (
								<Button
									onClick={() => {
										remakeCredit();
									}}
									variant="outlined"
									startIcon={<FontAwesomeIcon icon={faGears} />}
									sx={{
										whiteSpace: 'nowrap',
										color: 'text.secondary',
										borderColor: 'divider'
									}}
								>
									Reconstruir
								</Button>
							) : (
								<></>
							)}

							<Button
								onClick={() => {
									setShowModal(true);
								}}
								variant="outlined"
								startIcon={<FontAwesomeIcon icon={faCodePullRequest} />}
								sx={{
									whiteSpace: 'nowrap',
									color: 'text.secondary',
									borderColor: 'divider'
								}}
							>
								Reestructurar
							</Button>
						</Stack>
					</Stack>
				</Paper>

				{/* Las dos tarjetas van como hermanas de la cabecera, no anidadas
				    dentro: es la estructura que usa CrediHouse_Formats. */}
				<Grid container spacing={2.5} sx={{ marginTop: '2px' }}>
						<Grid item xs={12} md={6}>
							<Paper sx={{ padding: '22px', height: '100%' }}>
								<Typography sx={tituloTarjetaSx}>Condiciones del crédito</Typography>
								<Stack spacing={2}>
								<TextField
									disabled={!isEdit || isAbonado}
									required
									fullWidth
									onChange={(e) => funtionSetMontoSolicitado(e.target.value)}
									value={montoPrincipal}
									label={'Monto Solicitado'}
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">C$</InputAdornment>
										)
									}}
								/>

								<FormControl fullWidth style={{ textAlign: 'left' }}>
									<InputLabel id="demo-simple-select-standard-label">
										Lista de Fiadores
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										label="Lista de Fiadores"
										style={{ textAlign: 'left' }}
									>
										<MenuItem value="">
											<em>Lista de Fiadores</em>
										</MenuItem>
										{fiadorList.map((item) => {
											return (
												// La key va en el elemento raiz que devuelve el map:
												// antes estaba en el MenuItem interno, que React no ve.
												<Stack
													key={item.id}
													direction="row"
													justifyContent="space-between"
													paddingLeft={1}
													paddingRight={1}
												>
													<MenuItem>
														{item.fullName}
													</MenuItem>
													<IconButton
														style={{
															color: '#c77f12'
														}}
														onClick={() => {
															onClickEditFiador(item);
														}}
													>
														<FontAwesomeIcon icon={faPenToSquare} />
													</IconButton>
												</Stack>
											);
										})}
									</Select>
								</FormControl>

								{mostrarDiaAtencion ? (
									<FormControl
										disabled={!isEdit}
										fullWidth
										style={{ textAlign: 'left' }}
									>
										<InputLabel id="select-dia-atencion-label">
											Dia de Atencion
										</InputLabel>
										<Select
											labelId="select-dia-atencion-label"
											onChange={(e) => setDiaAtencion(e.target.value)}
											value={diaAtencion}
											label="Dia de Atencion"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Seleccione un Dia</em>
											</MenuItem>
											{DIAS_ATENCION.map((dia) => (
												<MenuItem key={dia} value={dia}>
													{dia}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								) : null}

								<FormControl
									disabled={!isEdit}
									fullWidth
									style={{ textAlign: 'left' }}
								>
									<InputLabel id="demo-simple-select-standard-label">
										Gestor
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										onChange={(e) => setSelectedGestor(e.target.value)}
										value={selectedGestor}
										label="Gestor"
										style={{ textAlign: 'left' }}
									>
										<MenuItem value="">
											<em>Seleccione un Gestor</em>
										</MenuItem>
										{gestorList.map((item) => {
											return (
												<MenuItem key={item.id} value={item.id}>
													{item.fullName}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>

								<FormControl
									disabled={!isEdit}
									fullWidth
									style={{ textAlign: 'left' }}
								>
									<InputLabel id="demo-simple-select-standard-label">
										Promotor
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										onChange={(e) => setSelectedPromotor(e.target.value)}
										value={selectedPromotor}
										label="Promotor"
										style={{ textAlign: 'left' }}
									>
										<MenuItem value="">
											<em>Seleccione un promotor</em>
										</MenuItem>
										{promotorList.map((item) => {
											return (
												<MenuItem key={item.id} value={item.id}>
													{item.fullName}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>

								<TextField
									disabled={!isEdit || isAbonado}
									required
									fullWidth
									onChange={(e) => setDestino(e.target.value.toUpperCase())}
									value={destino}
									label={'Destino'}
								/>

								<FormControl
									disabled={!isEdit}
									fullWidth
									style={{ textAlign: 'left', marginTop: 20 }}
								>
									<InputLabel id="demo-simple-select-standard-label">
										Tipo de Credito
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										onChange={(e) => setTipoCredito(e.target.value)}
										value={tipoCredito}
										label="Tipo de Credito"
									>
										<MenuItem value={9}>PERSONAL</MenuItem>
										<MenuItem value={19}>MICRO CREDITO</MenuItem>
									</Select>
								</FormControl>

								<TextField
									disabled
									required
									fullWidth
									value={isReportado ? 'SI' : 'NO'}
									label={'Reportado'}
								/>
								</Stack>
							</Paper>
						</Grid>

						<Grid item xs={12} md={6}>
							<Paper sx={{ padding: '22px', height: '100%' }}>
								<Typography sx={tituloTarjetaSx}>Gestión y plazos</Typography>
								<Stack spacing={2}>
								<FormControl
									disabled={!isEdit || isAbonado}
									fullWidth
									style={{ textAlign: 'left' }}
								>
									<InputLabel id="demo-simple-select-standard-label">
										Periodicidad
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										onChange={handleChangePeriodicidad}
										value={selectedPeriodicidad}
										label="Periodicidad"
										style={{ textAlign: 'left' }}
									>
										<MenuItem value="">
											<em>Seleccione un Periodo</em>
										</MenuItem>
										{periodicidadList.map((item) => {
											return (
												<MenuItem key={item.id} value={item.id}>
													{item.description}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>

								<FormControl
									disabled={!isEdit || isAbonado}
									fullWidth
									style={{ textAlign: 'left' }}
								>
									<InputLabel id="demo-simple-select-standard-label">
										Plazo
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										onChange={(e) => setSelectedPlazo(e.target.value)}
										value={selectedPlazo}
										label="Plazo"
										style={{ textAlign: 'left' }}
									>
										<MenuItem value="">
											<em>Seleccione un Plazo</em>
										</MenuItem>
										{plazoList.map((item) => {
											return (
												<MenuItem key={item.id} value={item.id}>
													{item.description}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>

								<FormControl
									disabled={!isEdit || isAbonado}
									fullWidth
									style={{ textAlign: 'left' }}
								>
									<InputLabel id="demo-simple-select-standard-label">
										Tasa de interes
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										onChange={(e) =>
											setSelectedInteresCorriente(e.target.value)
										}
										value={selectedInteresCorriente}
										label="Tasa de interes"
										style={{ textAlign: 'left' }}
									>
										<MenuItem value="">
											<em>Seleccione una Tasa de Interes</em>
										</MenuItem>
										{interesCorrienteList.map((item) => {
											return (
												<MenuItem key={item.id} value={item.id}>
													{`${item.intCorriente.toFixed(2)} %`}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>

								<DesktopDatePicker
									disabled
									closeOnSelect
									label="Fecha de Entrega"
									inputFormat="DD/MM/YYYY"
									value={fechaEntrega}
									onChange={(newValue) => setFechaEntrega(newValue)}
									renderInput={(params) => <TextField {...params} />}
								/>

								<DesktopDatePicker
									disabled={!isEdit || isAbonado}
									closeOnSelect
									label="Fecha Primera Cuota"
									inputFormat="DD/MM/YYYY"
									value={fechaPrimeraCuota}
									onChange={(newValue) => setFechaPrimeraCuota(newValue)}
									renderInput={(params) => <TextField {...params} />}
								/>

								<DesktopDatePicker
									disabled
									closeOnSelect
									label="Fecha Vencimiento"
									inputFormat="DD/MM/YYYY"
									value={fechaVenc}
									onChange={(newValue) => setFechaVenc(newValue)}
									renderInput={(params) => <TextField {...params} />}
								/>

								{isAccess(access, 'CREDITS UPDATE') ? (
									<Button
										variant="contained"
										color="primary"
										startIcon={<FontAwesomeIcon icon={faSave} />}
										onClick={() => saveChanges()}
										sx={{ height: 46, paddingX: 2.5 }}
										disabled={!isEdit}
									>
										Actualizar crédito
									</Button>
								) : (
									<></>
								)}
								</Stack>
							</Paper>
						</Grid>
					</Grid>

			<SmallModal
				titulo={'Reestructurar Credito'}
				isVisible={showModal}
				setVisible={setShowModal}
			>
				<Reestructuracion
					setShowModal={setShowModal}
					id={id}
					periodicidadList={periodicidadList}
				/>
			</SmallModal>

			<MediumModal
				titulo={'Editar Fiador'}
				isVisible={showModalFiafor}
				setVisible={setShowModalFiador}
			>
				<EditarFiador
					setShowModal={setShowModalFiador}
					selectedfiador={selectedfiador}
					isUpdate={isUpdate}
					setIsUpdate={setIsUpdate}
				/>
			</MediumModal>
		</div>
	);
};

export default CreditDetails;
